import styled from 'styled-components'
import { Container } from 'src/components/common/Container'
import cu_logo from 'src/assets/images/main/main_convenient_banner_icon.png'
import { Typography } from 'src/components/common/Typography'
import { Noto_body2_b14, Noto_body3_b12 } from 'src/styles/fonts/NotoSansKrFonts'
import usePageNav from 'src/hooks/usePageNav.hook'
import { mediaMaxWidth } from 'src/styles/mixin'

const MainFreeCouponShortcut = () => {
  const { freeCouponPageNav } = usePageNav()
  return (
    <S.MainFreeCouponShortcutContainer $option="flex_row">
      <S.MainFreeCouponShortcut.Container $option="flex_row_space_between" $column_gap="10px">
        <S.MainFreeCouponShortcut.ConvenientBarcodeIcon src={cu_logo} />
        <S.MainFreeCouponShortcut.TextContainer $option="flex_column">
          <Typography $fontStyle={Noto_body2_b14}>편의점 할인쿠폰 지급완료</Typography>
        </S.MainFreeCouponShortcut.TextContainer>
        <S.MainFreeCouponShortcut.CouponBoxChips>
          <Typography $fontStyle={Noto_body3_b12} $color="var(--white)" onClick={freeCouponPageNav}>
            쿠폰함
          </Typography>
        </S.MainFreeCouponShortcut.CouponBoxChips>
      </S.MainFreeCouponShortcut.Container>
    </S.MainFreeCouponShortcutContainer>
  )
}
export default MainFreeCouponShortcut

const S = {
  MainFreeCouponShortcutContainer: styled(Container)`
    margin: 0 auto;
    max-width: 420px;
    ${mediaMaxWidth('460')} {
      max-width: unset;
      padding: 0 20px;
    }
  `,
  MainFreeCouponShortcut: {
    Container: styled(Container)`
      padding: 12px 18px;
      border-radius: 12px;
      border: 1px solid var(--brand-20);
      background: var(--brand-5);
      align-items: center;
    `,
    TextContainer: styled(Container)``,
    CouponBoxChips: styled.section`
      border-radius: 20px;
      background: var(--brand-50);
      padding: 4px 8px;
      min-width: 50px;
      cursor: pointer;
    `,
    ConvenientBarcodeIcon: styled.img`
      width: 42px;
      height: 100%;
    `,
  },
}
